import { render, staticRenderFns } from "./WxOpenLaunchAppWrap.vue?vue&type=template&id=071a7c9c&scoped=true&"
import script from "./WxOpenLaunchAppWrap.vue?vue&type=script&lang=js&"
export * from "./WxOpenLaunchAppWrap.vue?vue&type=script&lang=js&"
import style0 from "./WxOpenLaunchAppWrap.vue?vue&type=style&index=0&id=071a7c9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a7c9c",
  null
  
)

export default component.exports